import React from "react";
import { Link, useLocation } from "react-router-dom";

const CustomerSidebar = () => {
  const location = useLocation(); // Get the current location

  // Helper function to determine if the route is active
  const isActive = (path) => location.pathname === path;

  return (
    <div className="reviewcls p-1 box_detail">
      <div className="mb-1">
        <Link to="/my-account" className="xtnone">
          <div className={isActive("/my-account") ? "mqnuu1active" : "mqnuu1"}>
            My Account
          </div>
        </Link>
      </div>

      <div className="mb-1">
        <Link to="/customer/change-password" className="xtnone">
          <div
            className={isActive("/customer/change-password") ? "mqnuu1active" : "mqnuu1"}
          >
            Change Password
          </div>
        </Link>
      </div>

      <div className="mb-1">
        <Link to="/my-listing" className="xtnone">
          <div className={isActive("/my-listing") ? "mqnuu1active" : "mqnuu1"}>
            My Listing
          </div>
        </Link>
      </div>

      <div className="mb-1">
        <Link to="/logout" className="xtnone">
          <div className={isActive("/logout") ? "mqnuu1active" : "mqnuu1"}>
            Logout
          </div>
        </Link>
      </div>
    </div>
  );
};

export default CustomerSidebar;
